export default __webpack_public_path__ + "static/media/creditcard.1f2f8521.png";